export class EventModel {

    public id: number;
    public typeId: number;
    public statusId: number;
    public intervalId: number;
    public description: string;
    public date: string;
    public notify: boolean;
    public creator: string;
    public creatorId: string;
    public assignedToId: string;
    public assignedTo: string;

    constructor(obj?: any) {
        this.id             = obj && obj.id           || null;
        this.typeId         = obj && obj.typeId       || null;
        this.statusId       = obj && obj.statusId     || null;
        this.intervalId     = obj && obj.intervalId   || null;
        this.description    = obj && obj.description  || '';
        this.date           = obj && obj.date         || '';
        this.notify         = obj && obj.notify       || false;
        this.creator        = obj && obj.creator      || '';
        this.creatorId      = obj && obj.creatorId    || '';
        this.assignedToId   = obj && obj.assignedToId || '';
        this.assignedTo     = obj && obj.assignedTo   || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/event.model.ts